var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#0f0034",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,2h-16c-1.10156,0 -2,0.89844 -2,2v16c0,1.10156 0.89844,2 2,2h16c1.10156,0 2,-0.89844 2,-2v-16c0,-1.10156 -0.89844,-2 -2,-2zM8.39844,15.10156h-2.19922c-0.19922,0 -0.30078,-0.20312 -0.19922,-0.40234l2.30078,-4.19922c0,-0.10156 0,-0.19922 0,-0.19922l-1.5,-2.60156c-0.10156,-0.19922 0,-0.39844 0.19922,-0.39844h2.19922c0.10156,0 0.19922,0 0.19922,0.09766l1.70313,2.90234c0,0.09766 0,0.19922 0,0.19922l-2.5,4.5c0,0.10156 -0.10156,0.10156 -0.20312,0.10156zM18,5.39844l-4.39844,8.10156c0,0.10156 0,0.19922 0,0.19922l2.89844,5c0.10156,0.19922 0,0.40234 -0.19922,0.40234h-2.30078c-0.10156,0 -0.19922,0 -0.19922,-0.10156l-3,-5.19922c0,-0.10156 0,-0.19922 0,-0.19922l4.59766,-8.30078c0,-0.30078 0.10156,-0.30078 0.20313,-0.30078h2.19922c0.09766,0 0.30078,0.19922 0.19922,0.39844z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXing);
export default __webpack_public_path__ + "static/media/xing.80d135b09709f140dfdddaebbf41415d.svg";
export { ForwardRef as ReactComponent };